import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/login-page/Login";
import RequestAccess from "..//pages/request-access/RequestAccess";
import Home from "../features/home/pages/Home";
import AppLayout from "../components/layout/AppLayout";
import RoleGuard from "./RoleGuard";
import Forbidden from "../pages/forbidden-page/Forbidden";
import ErrorPage from "../pages/error-page/Error";

import ProfileTeam from "../features/profile/pages/ProfileTeamPage/ProfileTeam";
import Reports from "../features/evaluations/pages/Reports/Reports";
import SelectColleagues from "../features/evaluations/pages/SelectColleagues/SelectColleagues";
import EmployeeInfo from "../features/employees/pages/EmployeeInfo";
import RequireAuth from "./RequireAuth";
import NotRegistered from "../pages/not-registered-page/NotRegistered";
import PublicQuestionnairePage from "../features/questionnaires/pages/PublicQuestionnaire/PublicQuestionnaire";
import Questionnaire from "../features/questionnaires/pages/Questionnaire/QuestionnairePage";
import Report from "../features/reports/pages/report";
import FullNotesPage from "../features/profile/pages/FullResultsPage/FullNotesPage";
import FullReportsPage from "../features/profile/pages/FullResultsPage/FullReportsPage";
import MyTeam from "../features/employeeTeams/pages/MyTeam";
import AllEmployees from "../features/employees/pages/AllEmployees";
import { UserProvider } from "../context/UserContext";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/request-access" element={<RequestAccess />} />
      <Route path="/not-registered" element={<NotRegistered />} />
      <Route>
        <Route path="/feedback/:key" element={<PublicQuestionnairePage />} />
      </Route>

      <Route path="/error" element={<ErrorPage />} />

      <Route element={<UserProvider><RequireAuth /></UserProvider>}>
        <Route element={<AppLayout />}>
          <Route path="/home" element={<Home />} />
          <Route path="/select-colleagues" element={<SelectColleagues />} />
          <Route path="/questionnaire" element={<Questionnaire />} />

          <Route
            element={<RoleGuard allowedRoles={["Team Leader", "Management", "RH"]} />}
          >
            <Route path="/my-team" element={<MyTeam />} />
            <Route path="/employees/:employeeId" element={<EmployeeInfo />} />
            <Route path="/profile-team/:employeeId" element={<ProfileTeam />} />
            <Route
              path="/profile-team/:employeeId/notes"
              element={<FullNotesPage />}
            />
            <Route
              path="/profile-team/:employeeId/reports"
              element={<FullReportsPage />}
            />
          </Route>

          <Route element={<RoleGuard allowedRoles={["Management", "RH"]} />}>
            <Route path="/all-employees" element={<AllEmployees />} />
          </Route>

          <Route path="/reports" element={<Reports />} />

          <Route path="/forbidden" element={<Forbidden />} />

          <Route path="/report/:evaluationid" element={<Report />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
